@if (isZeroDesktop()) {
  <div
    class="desktop-header"
    [class.non-clickable]="!zeroDesktopClickable()"
    [attr.tabindex]="zeroDesktopClickable() ? 0 : null"
    (click)="zeroDesktopClickable() && onHeaderClick()"
    (keyup.enter)="zeroDesktopClickable() && onHeaderClick()"
    (keydown.space)="onDesktopHeaderKeydownSpace($event)"
  >
    <div class="header-title">
      <span class="icon" [style.--icon-url]="'url(' + icon() + ')'"></span>
      <h3 class="title">{{ title() }}</h3>
    </div>
    <div class="header-details">
      @if (updatedAt()) {
        <span class="meta">
          <app-time-ago [updatedAt]="updatedAt()" format="short"></app-time-ago>
        </span>
      }
      <button
        class="action-link"
        type="button"
        (click)="!zeroDesktopClickable() && onHeaderClick()"
      >
        <span>{{ actionLabel() }}</span>
        <span class="chevron"></span>
      </button>
    </div>
  </div>
} @else if (isFinnetDesktop()) {
  <div
    class="finnet-desktop-header"
    tabindex="0"
    (click)="onHeaderClick()"
    (keyup.enter)="onHeaderClick()"
    (keydown.space)="$event.preventDefault(); onHeaderClick()"
  >
    <div class="finnet-desktop-title-group">
      <h2 class="finnet-desktop-title">{{ title() }}</h2>
      @if (updatedAt()) {
        <span class="finnet-desktop-meta">
          <app-time-ago [updatedAt]="updatedAt()" format="short"></app-time-ago>
        </span>
      }
    </div>
    <button class="finnet-action-link" type="button">
      <span>{{ actionLabel() }}</span>
      <span class="caret"></span>
    </button>
  </div>
} @else if (isFinnet()) {
  <div
    class="header"
    tabindex="0"
    (click)="onHeaderClick()"
    (keyup.enter)="onHeaderClick()"
    (keydown.space)="$event.preventDefault(); onHeaderClick()"
  >
    <h3 class="title">{{ title() }}</h3>
    @if (updatedAt()) {
      <app-time-ago class="updated-at" [updatedAt]="updatedAt()" format="compact"></app-time-ago>
    }
  </div>
} @else {
  <div
    class="header"
    tabindex="0"
    (click)="onHeaderClick()"
    (keyup.enter)="onHeaderClick()"
    (keydown.space)="$event.preventDefault(); onHeaderClick()"
  >
    <div class="header-title">
      <span class="icon" [style.--icon-url]="'url(' + icon() + ')'"></span>
      <h3 class="title">{{ title() }}</h3>
    </div>
    <div class="header-details">
      @if (updatedAt()) {
        <app-time-ago class="updated-at" [updatedAt]="updatedAt()" format="compact"></app-time-ago>
      }
      <button class="details" type="button">
        <span>Details</span>
        <span class="chevron"></span>
      </button>
    </div>
  </div>
}
